module.exports = __webpack_public_path__ + "img/pdf.fee434b2.png";